import { mapGetters } from 'vuex'
export const common_mixins = {
    props: {
        value: {
            type: Object,
        },
    },
    computed: {
        ...mapGetters({
            contract_types: 'async/contract_types',
          }),
         is_financer() {
            const cur_customer = this.$store.state.cur_customer
            return cur_customer.groups && cur_customer.groups.includes('GROUP_FIN');
         },
         is_financer_assistant() {
            const cur_customer = this.$store.state.cur_customer
            return cur_customer.groups && cur_customer.groups.includes('GROUP_FIN_INTERN');
         },
         tf_records_out_params() {
             return {
                query_all:this.is_financer,
                relate_type: 'payment_bill',
                contract_type:  this.params.payment_purpose === 'outsource' ? 'OutsourceContract' : 'Contract',
                contract_id: this.params.payment_purpose === 'outsource' ? this.params.outsource_contract_id : this.params.contract_id,
                size: 30 
             }
         },
         jc_records_out_params() {
             const {size, ...other} = this.tf_records_out_params
             return other
         }
    },
    data() {
        return {
            params: this.value,
        }
    },
    watch: {
        params(new_val) {
            this.$emit('input', new_val)
        },
        value(new_val) {
            this.params = new_val
        },
    },
    methods: {
        validate() {
           return this.$refs.base && this.$refs.base.validate()
        },
        resetValidation() {
            return this.$refs.base && this.$refs.base.resetValidation()
        }
    },
    created() {
        // 建立索引
        this.is_financer
    }
}

export const financer_mix = {
    computed: {
        is_financer() {
            const cur_customer = this.$store.state.cur_customer
            return cur_customer.groups && cur_customer.groups.includes('GROUP_FIN');
        },
    }
}